<div class="ws-screen-body">
  <div class="change-facility" [ngStyle]="dataService.windowInnerHeight$() | async">
    <div class="change-facility__title">Change Facility</div>
    <div class="zgridmenu">
      <!-- MENU -->
      <div class="zgridmenu--nogrow">
        <div
          class="zgridmenu__def"
          [class.zgridmenu__def--menu]="(authService.changeFacilityShowing | async) === 'grid'"
          [class.zgridmenu__grid--show]="showGrid"
        >
          <app-grid-menu [menuList]="menuList" [helpList]="helpList"></app-grid-menu>
        </div>
      </div>

      <!-- FITLER SCREEN -->
      <div class="zgridmenu--nogrow">
        <div class="zgridmenu__def" [class.zgridmenu__def--filter]="(authService.changeFacilityShowing | async) === 'filter'">
          <app-change-facility-filter></app-change-facility-filter>
        </div>
      </div>

      <!-- HELP SCREEN -->
      <div class="zgridmenu--nogrow">
        <div class="zgridmenu__def" [class.zgridmenu__def--help]="(authService.changeFacilityShowing | async) === 'help'">
          <app-grid-help [goBack]="showMain" [helpList]="helpList"></app-grid-help>
        </div>
      </div>

      <div class="zgridmenu--grow">
        <div class="zgridmenu__grid" [class.zgridmenu__grid--show]="showGrid">
          <app-change-facility-grid></app-change-facility-grid>
        </div>
      </div>
    </div>
  </div>
</div>
